import React from "react"
import { ServicePageLayout } from "../../components/services/ServicePageLayout"
import { METADATA } from "../../components/meta/metadata"

export default function KnowledgeEngineeringPage() {
  return (
    <ServicePageLayout
      title={METADATA.knowledgeEngineering.title}
      metaDescription={METADATA.knowledgeEngineering.description}
      backgroundImage="/images/backgrounds/flickr-3053484996.jpg"
      backgroundAlt="Knowledge Engineering"
      headline="Knowledge Engineering:<br />The Foundation of Effective AI"
      tagline="AI is only as good as what it knows. Knowledge Engineering is how we structure what it needs to know."
      introContent={[
        "Your organisation holds decades of accumulated expertise - processes, terminology, decision frameworks, operational wisdom. Most of this knowledge lives in people's heads, scattered documents or tribal understanding. Generic AI tools cannot access it.",
        "We systematically capture, structure and organise this institutional knowledge into AI-ready systems. The result: AI that operates with genuine understanding of your operations, not surface-level pattern matching."
      ]}
      deliverables={[
        {
          title: "Knowledge Architecture development",
          description: "Systematic structuring of your institutional knowledge into taxonomies, ontologies and semantic frameworks that AI can consume and reason over"
        },
        {
          title: "Knowledge graph implementation",
          description: "Structured systems that capture relationships between concepts, processes and expertise - enabling AI to understand context, not just keywords"
        },
        {
          title: "Semantic analysis systems",
          description: "Tools that interpret meaning and intent within your specific domain, using your terminology and quality standards"
        },
        {
          title: "Integration with existing systems",
          description: "Connection to your document repositories, workflows and operational systems - knowledge flows from where it already lives"
        },
        {
          title: "Documentation and knowledge transfer",
          description: "Complete documentation ensuring your teams understand and can maintain the knowledge architecture"
        }
      ]}
      benefits={[
        {
          title: "Knowledge Compounds",
          description: "Unlike AI tools which depreciate and require rebuilding, structured knowledge becomes more valuable as AI models improve. Better models make your Knowledge Architecture more powerful, not obsolete."
        },
        {
          title: "Platform Agnostic",
          description: "Your Knowledge Architecture is not locked to any vendor, model or platform. As AI technology evolves, your structured knowledge moves with you - no rebuilding, no vendor lock-in."
        },
        {
          title: "Captures What Matters",
          description: "We capture the unwritten rules, operational wisdom and domain expertise that makes experienced professionals effective - not just documented procedures, but how work actually gets done."
        },
        {
          title: "Foundation for Everything",
          description: "Knowledge Engineering underpins all effective AI implementation. Partner AIs, workflow automation, decision support - all depend on structured knowledge to operate effectively in your context."
        }
      ]}
      audience={[
        "Organisations implementing AI seriously, beyond experimentation",
        "Enterprises with significant institutional knowledge to capture",
        "Organisations concerned about knowledge loss through retirements or turnover",
        "Any sector where operational expertise creates competitive advantage",
        "Teams wanting AI that genuinely understands their domain"
      ]}
      relatedServices={[
        {
          name: "Partner AI",
          description: "Deploy conversational intelligence trained on your Knowledge Architecture",
          href: "/services/partner-ai"
        },
        {
          name: "AI Kickstarter",
          description: "8-week programme including Knowledge Engineering foundation",
          href: "/services/ai-kickstarter"
        }
      ]}
      ctaHeadline="Want to See How This Works?"
      ctaDescription="Book a demo and we'll show you Knowledge Architecture in action - then explore what structured knowledge could mean for your organisation."
      ctaButtonText="Schedule a Consultation"
    />
  )
}
